<app-announcement-bar *ngIf="!isMaintenancePage"></app-announcement-bar>
<app-navbar [navBarData]="headerData" *ngIf="!isMaintenancePage"></app-navbar>
<router-outlet></router-outlet>
<ws-app-chatbot></ws-app-chatbot>

<!-- Global Toast Notifications -->
<ngb-toast
  *ngIf="(toastService.toast$ | async)?.show && (toastService.toast$ | async)?.message"
  [class]="'notification-toast text-white bg-' + (toastService.toast$ | async)?.type"
  [autohide]="(toastService.toast$ | async)?.autohide"
  [delay]="(toastService.toast$ | async)?.delay"
  (hide)="toastService.hide()"
  [style.position]="'fixed'"
  [style.bottom]="'20px'"
  [style.left]="'50%'"
  [style.transform]="'translateX(-50%)'"
  [style.zIndex]="'9999'"
  [style.minWidth]="'300px'"
  [style.marginLeft]="'auto'"
  [style.marginRight]="'auto'">
  <div class="d-flex justify-content-between align-items-center">
    <span>{{ (toastService.toast$ | async)?.message }}</span>
    <button type="button" class="btn-close ms-2" (click)="toastService.hide()"></button>
  </div>
</ngb-toast>